import styles from 'css/src/components/common/ui/UpsellIcon.module.scss';

import React from 'react';
import classNames from 'classnames';

export enum ICON_SIZES {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}

const SIZE_CLASS: Record<ICON_SIZES, string> = {
    [ICON_SIZES.XS]: styles['xs'],
    [ICON_SIZES.SM]: styles['sm'],
    [ICON_SIZES.MD]: styles['md'],
    [ICON_SIZES.LG]: styles['lg'],
    [ICON_SIZES.XL]: styles['xl'],
};

type Props = {
    className?: string;
    isBadge?: boolean;
    isOutlined?: boolean;
    onClick?: (e: React.MouseEvent) => void;
    size?: ICON_SIZES;
};

/**
 * Upsell Icon.
 */
const MemoizedUpsellIcon = React.memo(function UpsellIcon({
    className,
    isBadge = false,
    isOutlined = false,
    onClick,
    size = ICON_SIZES.MD,
    ref,
}: Props & { ref?: React.Ref<HTMLInputElement> }) {
    const classNameValue = classNames(
        className,
        SIZE_CLASS[size],
        styles['upsell-icon'],
        'material-symbols-outlined',
        {
            'material-symbols-f1': !isOutlined,
            [styles['locked-badge']]: isBadge,
            [styles['clickable']]: !!onClick,
        },
    );
    return (
        <i ref={ref} translate="no" className={classNameValue} onClick={onClick}>
            workspace_premium
        </i>
    );
});
export default MemoizedUpsellIcon;
